<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    size="md"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok="onSaveClicked($event)"
    @cancel="$emit('cancel')"
  >
    <b-form>
      <b-row>
        <b-col cols="12" lg="6">
          <b-form-group label="Tipo">
            <b-form-select
              v-model="event.type"
              v-validate="rules.type"
              class="form-control"
              :options="typeOpts"
              aria-describedby="invalidType"
              name="type"
              :state="validateState('state')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidType">
              {{ errors.first("type") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          v-if="event.type === OmbudsmanEventType.STATUS_CHANGE"
          cols="12"
          lg="6"
        >
          <b-form-group label="Status">
            <b-form-select
              v-model="event.status"
              v-validate="rules.status"
              class="form-control"
              :options="statusOpts"
              aria-describedby="invalidStatus"
              name="status"
              :state="validateState('status')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidStatus">
              {{ errors.first("status") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          v-if="event.type === OmbudsmanEventType.COPY_TO_COMPLAINTS"
          cols="12"
          lg="6"
        >
          <b-form-group label="Encerrar Ouvidoria original?">
            <b-form-checkbox
              v-model="event.closeOmbudsman"
              name="closeOmbudsman"
              switch
              class="mt-2"
            >
              {{ event.closeOmbudsman ? "Sim" : "Não" }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          companyClassification.ombudsmanClosure.enabled &&
          ((event.type === OmbudsmanEventType.STATUS_CHANGE &&
            event.status === OmbudsmanStatus.CONCLUDED) ||
            (event.type === OmbudsmanEventType.COPY_TO_COMPLAINTS &&
              event.closeOmbudsman))
        "
      >
        <b-col>
          <b-form-group label="Indicador de Encerramento">
            <b-form-select
              v-model="event.ombudsmanClosure"
              v-validate="rules.closure"
              class="form-control"
              :options="classificationOptions.ombudsmanClosure"
              aria-describedby="invalidClosure"
              name="closure"
              :state="validateState('closure')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidClosure">
              {{ errors.first("closure") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          [
            OmbudsmanEventType.WITH_ATTACHMENT,
            OmbudsmanEventType.TASK,
          ].includes(event.type)
        "
      >
        <b-col cols="12">
          <b-form-group
            label="Anexo"
            :state="fileValidated"
            invalid-feedback="Adicione um arquivo"
          >
            <single-file-upload
              ref="upload"
              :post-action="upload.postAction"
              :data="upload.data"
              :disabled="uploading || uploadComplete"
              @upload-complete="onProcessingFinished"
              @file-changed="validateFile()"
            >
            </single-file-upload>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="event.type === OmbudsmanEventType.TASK">
        <b-col cols="6">
          <b-form-group label="E-mail">
            <b-form-input
              v-model="event.task.email"
              v-validate="rules.task.email"
              class="form-control"
              aria-describedby="invalidTaskEmail"
              name="taskEmail"
              :state="validateState('taskEmail')"
            ></b-form-input>
            <b-form-invalid-feedback id="invalidTaskEmail">
              {{ errors.first("taskEmail") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Prazo">
            <b-form-input
              v-model="event.task.dueDate"
              v-validate="rules.task.dueDate"
              class="form-control"
              type="date"
              :min="minDeadline"
              aria-describedby="invalidTaskDeadline"
              name="taskDeadline"
              :state="validateState('taskDeadline')"
            ></b-form-input>
            <b-form-invalid-feedback id="invalidTaskDeadline">
              {{ errors.first("taskDeadline") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Descrição">
            <b-form-textarea
              v-model="event.description"
              v-validate="rules.description"
              type="text"
              class="form-control"
              :rows="4"
              :max-rows="4"
              aria-describedby="invalidDescription"
              name="description"
              :state="validateState('description')"
            ></b-form-textarea>
            <b-form-invalid-feedback id="invalidDescription">
              {{ errors.first("description") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import OmbudsmanStatus from "../../../../backend/models/ombudsman/OmbudsmanStatus.ts";
import OmbudsmanEventType from "../../../../backend/models/ombudsman/OmbudsmanEventType.ts";
import { getStatusText } from "../complaints/utils";
import { createOmbudsmanEvent } from "@/api/ombudsman";
import SingleFileUpload from "../../components/SingleFileUpload";
import moment from "moment";
import { getCompanyUsers } from "@/api/company";
import { mapGetters } from "vuex";

export default {
  name: "OmbudsmanEventModal",
  components: { SingleFileUpload },
  props: {
    record: {
      type: Object,
      default: null,
    },
    pendency: {
      type: Object,
      default: null,
    },
    task: {
      type: Object,
      default: null,
    },
  },
  data() {
    const classification = {
      ombudsmanClosure: this.record.classification
        ? this.record.classification.ombudsmanClosure
        : null,
    };
    const companyClassification = {
      ombudsmanClosure: {},
    };
    if (
      this.record.company.classification &&
      this.record.company.classification.ombudsmanClosure?.enabled
    ) {
      companyClassification.ombudsmanClosure.enabled =
        this.record.company.classification.ombudsmanClosure.enabled;
    } else {
      companyClassification.ombudsmanClosure = true;
    }

    const statusOpts = [];
    for (const status of Object.keys(OmbudsmanStatus)) {
      if (status === "NEW") {
        continue;
      }

      const text = getStatusText(OmbudsmanStatus[status]);
      statusOpts.push({ value: OmbudsmanStatus[status], text });
    }

    return {
      classification,
      companyClassification,
      minDeadline: moment().format("YYYY-MM-DD"),
      OmbudsmanStatus,
      OmbudsmanEventType,
      statusOpts,
      typeOpts: [],
      event: {
        type: OmbudsmanEventType.FREE_TEXT,
        pendency: { user: null },
        task: { email: null },
        status: null,
        closeOmbudsman: false,
        ombudsmanClosure: null,
      },
      uploading: false,
      uploadComplete: false,
      fileValidated: true,
      companyUsers: [],
      managedByCompanyUsers: [],
      userOpts: [],
      upload: {
        postAction: "",
        data: {},
      },
      saving: false,
    };
  },
  computed: {
    ...mapGetters(["profile", "classificationOptions"]),
    modalTitle() {
      if (this.pendency) {
        return `Resolução de pendência da movimentação #${this.pendency.number}`;
      }
      if (this.task) {
        return `Resolução de tarefa de terceiros da movimentação #${this.task.number}`;
      }
      return "Adicionar Movimentação";
    },
    rules() {
      return {
        type: { required: true },
        description: { required: true },
        status: {
          required: this.event.type === OmbudsmanEventType.STATUS_CHANGE,
        },
        closure: {
          required:
            (this.event.type === OmbudsmanEventType.STATUS_CHANGE &&
              this.event.status === OmbudsmanStatus.CONCLUDED) ||
            (this.event.type === OmbudsmanEventType.COPY_TO_COMPLAINTS &&
              this.event.closeOmbudsman),
        },
        pendency: {
          user: {
            required: !!this.event.pendency.dueDate,
          },
          dueDate: {
            required: false,
          },
        },
        task: {
          email: {
            required: this.event.type === OmbudsmanEventType.TASK,
            email: true,
          },
          dueDate: {
            required: this.event.type === OmbudsmanEventType.TASK,
          },
        },
      };
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    validateFile() {
      if (this.event.type === OmbudsmanEventType.WITH_ATTACHMENT) {
        const file = this.$refs.upload.selectedFile();
        this.fileValidated = !!file;
      } else {
        this.fileValidated = true;
      }
    },
    async onSaveClicked(bvEvt) {
      bvEvt.preventDefault();
      if (this.saving) {
        return;
      }
      this.saving = true;
      try {
        await this.processSave();
      } finally {
        this.saving = false;
      }
    },
    async processSave() {
      const validated = await this.$validator.validateAll();
      this.validateFile();

      if (!validated || !this.fileValidated) {
        return;
      }

      let response;
      try {
        response = await createOmbudsmanEvent(this.record._id, this.event);
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      if (
        [OmbudsmanEventType.WITH_ATTACHMENT, OmbudsmanEventType.TASK].includes(
          this.event.type
        )
      ) {
        const event = response.data;
        this.uploading = true;

        const file = this.$refs.upload.selectedFile();

        if (file) {
          this.upload.postAction = `/api/ombudsman/${this.record._id}/events/${event._id}/file`;
          file.postAction = this.upload.postAction;
          file.headers = this.upload.headers;

          this.$nextTick(() => this.$refs.upload.start());
        } else {
          this.onProcessingFinished();
        }
      } else {
        this.onProcessingFinished();
      }
    },

    onProcessingFinished() {
      this.uploadComplete = true;
      this.uploading = false;

      this.$bvToast.toast("Evento criado com sucesso!", {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
      this.$emit("new-event");

      if (this.event.type === OmbudsmanEventType.STATUS_CHANGE) {
        this.$emit("status-changed", this.event.status);
      }

      if (this.event.type === OmbudsmanEventType.COPY_TO_COMPLAINTS) {
        const nextStatus = this.event.closeOmbudsman
          ? OmbudsmanStatus.CONCLUDED
          : this.record.status === OmbudsmanStatus.NEW
          ? OmbudsmanStatus.PROCESSING
          : this.record.status;
        this.$emit("status-changed", nextStatus);
      }

      if (this.pendency) {
        this.$emit("status-changed", OmbudsmanStatus.PROCESSING);
      }

      this.$refs.modal.hide();
    },

    async loadUserOpts() {
      const response = await getCompanyUsers(this.record.company._id, true);
      this.companyUsers = response.data;
      if (this.record.company.managedBy) {
        this.managedByCompanyUsers = (
          await getCompanyUsers(this.record.company.managedBy, true)
        ).data;
      }
      const userOpts = [];

      const getUserName = (id) => {
        let user = this.companyUsers.find((e) => e._id === id);
        if (user) {
          return `${user.name} ${user.surname}`;
        }
        user = this.managedByCompanyUsers.find((e) => e._id === id);
        return `${user.name} ${user.surname}`;
      };
      const myId = this.profile._id;
      let addedSelf = false;
      if (!addedSelf && !!this.profile.company) {
        userOpts.unshift({ value: myId, text: getUserName(myId) });
      }
      userOpts.unshift({ value: null, text: "" });
      this.userOpts = userOpts;
    },

    async show() {
      await this.loadUserOpts();
      this.event = {
        type: 1,
        pendency: { user: null },
        task: { email: null },
        closeOmbudsman: false,
        ombudsmanClosure: null,
      };
      if (this.pendency) {
        this.event.pendency.resolves = this.pendency._id;
      }
      if (this.task) {
        this.event.task.resolves = this.task._id;
      }
      const typeOpts = [
        { value: OmbudsmanEventType.FREE_TEXT, text: "Texto livre" },
        { value: OmbudsmanEventType.WITH_ATTACHMENT, text: "Com anexo" },
        { value: OmbudsmanEventType.TASK, text: "Tarefa de Terceiros" },
      ];
      if (!this.pendency) {
        typeOpts.push({
          value: OmbudsmanEventType.STATUS_CHANGE,
          text: "Mudança de Status",
        });
        typeOpts.push({
          value: OmbudsmanEventType.COPY_TO_COMPLAINTS,
          text: "Copiar para canal de denúncias",
        });
      }
      this.typeOpts = typeOpts;
      this.$refs.modal.show();
    },
  },
};
</script>
